export default "__VITE_ASSET__8af2b163__"